<template lang="pug">
  .logo-icon(:class="active? 'active': ''")
    svg.frame(viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg")
      g
        frame-path(ref="frame")
    .icon
      logo-image(ref="logoImage")
    //img(src="~assets/logo-deco.png")

    
</template>

<script>
import gsap from 'gsap'
import FramePath from '@/components/wedgits/FramePath'
import LogoImage from '@/components/wedgits/LogoImage'
export default {
  name: 'LogoIcon',
  components: { LogoImage, FramePath },
  data() {
    return {
      active: false,
      t1: 0,
    }
  },
  methods: {
    init() {
      //this.tl = gsap.timeline({})
    },
    frameAnime() {
      return gsap.timeline().to(this, { t1: 1, duration: 1 })
    },
    animeIn(offsets) {
      gsap
        .timeline({})
        .add(this.$refs.frame.animeIn(0.7), 0)
        .add(this.$refs.logoImage.animeIn(1), 0.5)
      // gsap.fromTo(
      //   this.$el,
      //   {
      //     opacity: 0,
      //   },
      //   {
      //     opacity: 1,
      //     duration: 0.7,
      //   }
      // )
    },
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.logo-icon
  position: relative
  width: 100%
  height: 100%
  opacity: 1
  transition: opacity 1s ease
  //background: #1664FF
  .frame
    width: 100%
    height: 100%
  .icon
    position: absolute
    top: -12%
    left: -12%
    width: 138%
    height: 138%
  //img
    width: 100%
    height: 100%
</style>
